export enum CommunicationType {
    REMINDER = 'REMINDER',
    SURVEY = 'SURVEY',
    INVOICE_ACCESS = 'INVOICE_ACCESS',
    // DIAGNOSIS_ACCESS = 'DIAGNOSIS_ACCESS',
    DOCUMENTATION_ACCESS = 'DOCUMENTATION_ACCESS',
    RESERVATION_NOTICE = 'RESERVATION_NOTICE',
    RESERVATION_CHANGE_NOTICE = 'RESERVATION_CHANGE_NOTICE',
    RESERVATION_REMINDER = 'RESERVATION_REMINDER',
    RESERVATION_CANCEL = 'RESERVATION_CANCEL',
    ACCESS_CODE = 'ACCESS_CODE',
    SLOT_RESERVATION = 'SLOT_RESERVATION',
    NEW_SUBCONTRACTOR_REQUEST = 'NEW_SUBCONTRACTOR_REQUEST',
    PWD_RENEWAL = 'PWD_RENEWAL',
    // PASSWORD_RENEWAL = 'PASSWORD_RENEWAL',
    GDPR_PERMISSION = 'GDPR_PERMISSION',
    TELEMEDICINE = 'TELEMEDICINE',
    COVID19 = 'COVID19',
    UNANSWERED_CALL = 'UNANSWERED_CALL',
}

// REMINDER,
// SURVEY,
// INVOICE_ACCESS,
// DIAGNOSIS_ACCESS,
// DOCUMENTATION_ACCESS,
// RESERVATION_NOTICE,
// RESERVATION_CHANGE_NOTICE,
// RESERVATION_REMINDER,
// RESERVATION_CANCEL,
// ACCESS_CODE,
// SLOT_RESERVATION,
// NEW_SUBCONTRACTOR_REQUEST,
// PWD_RENEWAL,
// PASSWORD_RENEWAL,
// GDPR_PERMISSION,
